export { UIGameBeginnerHint } from './UIGameBeginnerHint.tsx';
